import * as v from 'valibot';

export const EVENT_STATUS = ['ACCEPTED', 'TENTATIVE', 'DECLINED'] as const;
export const EventStatusScheme = v.picklist(EVENT_STATUS);

export const EVENT_STATE_VALUES = [
  'ACCEPTED',
  'TENTATIVE',
  'DECLINED',
  'NEEDS_ACTION',
  'DELEGATED',
] as const;
export const EventStateScheme = v.picklist(EVENT_STATE_VALUES);

export const EventSchema = v.object({
  channel: v.nullish(v.string()),
  cid: v.nullish(v.string()),
  state: v.nullish(EventStateScheme),
  updated: v.nullish(v.number()),
});

export type TEventStatus = v.Output<typeof EventStateScheme>;
export type TEvent = v.Output<typeof EventSchema>;
